// export default i18n;
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
// don't want to use this?
// have a look at the Quick start guide
// for passing in lng and translations on init
declare module "i18next" {
  interface CustomTypeOptions {
    returnNull: false;
  }
}

// SEO: <html lang> must reflect the active language (Belgium-specific for fr/nl).
const HTML_LANG_MAP: Record<string, string> = {
  en: "en",
  fr: "fr-BE",
  nl: "nl-BE",
};

const syncHtmlLang = (lng: string) => {
  document.documentElement.lang = HTML_LANG_MAP[lng] || "en";
};

// eslint-disable-next-line import/no-named-as-default-member
i18n
  // hload translation using ttp -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
  // learn more: https://github.com/i18next/i18next-http-backend
  // want your translations to be loaded from a professional CDN? => https://github.com/locize/react-tutorial#step-2---use-the-locize-cdn
  .use(Backend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    fallbackLng: "fr",
    lng: localStorage.getItem("i18nextLng") || "fr",
    debug: false,
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    react: {
      useSuspense: true,
    },
  })
  .then(() => syncHtmlLang(i18n.language));

i18n.on("languageChanged", syncHtmlLang);

export default i18n;
